import React from "react";
import "./SpeedSelect.css";

function SpeedSelectButton(props) {
  return (
    <button
      className={
        props.playbackSpeed.current === props.speedModifier
          ? "not-draggable btn speed-select active"
          : "not-draggable btn speed-select"
      }
      onClick={() => {
        props.playbackSpeed.update(props.panelId, props.speedModifier);
      }}
    >
      {props.speedModifier}x<i className="icon-play" />
    </button>
  );
}

export default SpeedSelectButton;
